exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span,ul.list li{display:inline-block;margin:2px}.list{margin:0 0 5px;padding:0;list-style-type:none}.list span{width:130px;margin-left:5px;padding:5px;color:#9561e2;border-radius:2px;font-size:13px;text-align:center;font-weight:700;transition:.2s;line-height:25px}.star{cursor:default}.star,.star.active{color:#9561e2}", ""]);

// exports
